import React from 'react';

export interface Props {
  src: string;
  srcFallback: string;
  containerClassName?: string;
  containerInlineStyle?: React.CSSProperties;
  imageClassName?: string;
  imageSize?: {
    width?: number;
    height?: number;
  };
}

const WebpWithFallback: React.FC<Props> = ({
  src,
  srcFallback,
  containerClassName,
  containerInlineStyle,
  imageClassName,
  imageSize
}) => (
  <picture className={containerClassName} style={containerInlineStyle}>
    <source srcSet={src} type="image/webp" />
    <img {...imageSize} className={imageClassName} src={srcFallback} alt="" />
  </picture>
);

export default WebpWithFallback;
